import DatoLink from '@/components/DatoLink/DatoLink'
import { cn } from '@desoutter/uikit'
import Image from 'next/image'
import { Image as DatoImage } from 'react-datocms'
import { DatoLinkFragment } from '@/components/DatoLink/DatoLink.generated'
import { PagelinksImagesCardFragment } from '@/components/blocks/PagelinksImagesBlock/PagelinksImagesCard/PagelinksImagesCard.generated'

export function MenuCardsFull({
	card,
	isVertical,
}: {
	card: PagelinksImagesCardFragment
	isVertical: boolean
}) {
	const cardClassName = cn(
		'grid grid-cols-5 gap-2 mb-4 items-center justify-start',
		{
			'grid-cols-1 gap-4': isVertical,
		},
	)
	return (
		<div key={card.id} className="group">
			<DatoLink
				fragment={card.link as DatoLinkFragment}
				className={cardClassName}
			>
				<div className="relative col-span-2 rounded-lg overflow-clip">
					<Image
						src="/images/linear-mask.png"
						alt="linear-mask"
						fill
						style={{ objectFit: 'cover' }}
						className="absolute bottom-0 w-full z-10 brightness-100 group-hover:brightness-150 duration-200"
					/>
					<DatoImage
						data={card.image?.responsiveImage}
						layout="responsive"
						objectFit="cover"
						className="h-32 group-hover:scale-105 duration-200"
					/>
				</div>

				<div
					className={cn(
						'flex flex-col col-span-3 group-hover:-translate-y-2 duration-200 w-full pr-2',
						{
							'gap-2': isVertical,
						},
					)}
				>
					<p className="text-base font-normal w-full">{card.title || ''}</p>
					<p className="text-sm text-gray-500 dark:text-gray-300 w-full">
						{card.subtitle || ''}
					</p>
				</div>
			</DatoLink>
		</div>
	)
}
